import { gsap } from "@gsap";

/**
 * Layout: Hero - Activiteit
 * Slug: hero_activiteit
 */

const initHeroAnimations = () => {
    document.querySelectorAll(".flex-layout.hero_activiteit-layout").forEach((layout) => {
        const svg = layout.querySelector(".shape");
        const segments = svg?.querySelectorAll("path");

        if (!svg || !segments?.length) return;

        const motion = gsap.matchMedia();

        motion.add(
            {
                reduce: "(prefers-reduced-motion: reduce)",
                animate: "(prefers-reduced-motion: no-preference)",
            },
            (context) => {
                if (context.conditions.reduce) {
                    gsap.set(segments, { opacity: 1 });
                    return;
                }

                // Per path, in SVG units: top-right, top-left, bottom-left, bottom-right
                const corners = [
                    { x: 160, y: -160 },
                    { x: -160, y: -160 },
                    { x: -160, y: 160 },
                    { x: 160, y: 160 },
                ];

                const tl = gsap.timeline({ delay: 0.5 });

                segments.forEach((segment, i) => {
                    const from = corners[i % corners.length];
                    tl.fromTo(
                        segment,
                        { x: from.x, y: from.y, opacity: 0 },
                        { x: 0, y: 0, opacity: 1, duration: 1.5, ease: "power3.out" },
                        i * 0.15,
                    );
                });

                return () => tl.kill();
            },
        );
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroAnimations, { once: true });
} else {
    initHeroAnimations();
}
